import styled from "@emotion/styled";
import Info from "@engineering/icons/info";
import { Theme } from "@silvertours/front-shared";
var Badge = /*#__PURE__*/ styled("div", {
    target: "em40rlz0"
})("position:absolute;right:0;top:-1.625rem;height:2.125rem;display:inline-flex;align-items:center;gap:0.5rem;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural70;
}, ";background-image:", function(param) {
    var theme = param.theme;
    return Theme.getLinearGradient(theme.gradient.orange, "to left");
}, ";color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:700;padding:0 1rem;border-radius:100px;", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{top:0;right:-1.5625rem;}svg{width:1.6rem;height:1.6rem;fill:", Theme.Color.natural0, ";vertical-align:middle;cursor:pointer;}");
var InfoIcon = /*#__PURE__*/ styled(Info, {
    target: "em40rlz1"
})("width:1.6rem;height:1.6rem;fill:currentcolor;vertical-align:middle;cursor:pointer;");
export { Badge, InfoIcon };
